"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var getValidProps_1 = require("@helpscout/react-utils/dist/getValidProps");

var Context_1 = require("../FormLabel/Context");

var VisuallyHidden_1 = require("../VisuallyHidden");

var classNames_1 = require("../../utilities/classNames");

var component_1 = require("../../utilities/component");

var id_1 = require("../../utilities/id");

var other_1 = require("../../utilities/other");

var Switch_css_js_1 = require("./styles/Switch.css.js");

var utils_1 = require("./utils");

var uniqueID = id_1.createUniqueIDFactory('Switch');

var Switch =
/** @class */
function (_super) {
  __extends(Switch, _super);

  function Switch(props) {
    var _this = _super.call(this, props) || this;

    _this.handleOnChange = function (event) {
      var _a = _this.props,
          onChange = _a.onChange,
          value = _a.value;
      var nextChecked = !_this.state.checked;
      /* istanbul ignore else */

      if (_this.shouldAutoUpdateChecked) {
        _this.setState({
          checked: nextChecked
        });
      }

      onChange(nextChecked, {
        event: event,
        value: value
      });
    };

    _this.handleOnClick = function (event) {
      event.stopPropagation();

      if (_this.props.isLoading) {
        event.preventDefault();
      } else {
        _this.props.onClick(event);
      }
    };

    _this.handleOnBlur = function (event) {
      _this.setState({
        isFocused: false
      });

      _this.props.onBlur(event);
    };

    _this.handleOnFocus = function (event) {
      _this.setState({
        isFocused: true
      });

      _this.props.onFocus(event);
    };

    _this.handleOnMouseDown = function (event) {
      _this.setState({
        isActive: true
      });

      _this.props.onMouseDown(event);
    };

    _this.handleOnMouseUp = function (event) {
      _this.setState({
        isActive: false
      });

      _this.props.onMouseUp(event);
    };

    _this.setInnerRef = function (node) {
      _this.props.inputRef(node);

      _this.props.innerRef(node);
    };

    _this.getIdFromContextProps = function (props) {
      if (props === void 0) {
        props = {
          id: ''
        };
      }

      return props.id || _this.state.id;
    };

    _this.getInputMarkup = function (props) {
      if (props === void 0) {
        props = {
          id: ''
        };
      }

      var _a = _this.props,
          propActive = _a.checked,
          disabled = _a.disabled,
          inputRef = _a.inputRef,
          innerRef = _a.innerRef,
          name = _a.name,
          value = _a.value,
          rest = __rest(_a, ["checked", "disabled", "inputRef", "innerRef", "name", "value"]);

      var checked = _this.state.checked;

      var id = _this.getIdFromContextProps(props);

      return React.createElement(Switch_css_js_1.InputUI, __assign({}, getValidProps_1.default(rest), {
        "aria-checked": checked,
        className: "c-Switch__input",
        checked: checked,
        disabled: disabled,
        id: id,
        name: name,
        onBlur: _this.handleOnBlur,
        onChange: _this.handleOnChange,
        onFocus: _this.handleOnFocus,
        onClick: _this.handleOnClick,
        innerRef: _this.setInnerRef,
        role: "switch",
        type: "checkbox",
        value: value
      }));
    };

    _this.state = {
      checked: props.checked || false,
      isActive: false,
      isFocused: false,
      id: props.id || uniqueID()
    };
    _this.shouldAutoUpdateChecked = props.checked === undefined;
    return _this;
  }

  Switch.prototype.componentWillReceiveProps = function (nextProps) {
    /* istanbul ignore else */
    if (nextProps.checked !== this.state.checked) {
      this.setState({
        checked: nextProps.checked
      });
    }
  };

  Switch.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        disabled = _a.disabled,
        onBlur = _a.onBlur,
        onChange = _a.onChange,
        onFocus = _a.onFocus,
        id = _a.id,
        isLoading = _a.isLoading,
        labelOn = _a.labelOn,
        labelOff = _a.labelOff,
        size = _a.size,
        state = _a.state,
        value = _a.value,
        rest = __rest(_a, ["className", "disabled", "onBlur", "onChange", "onFocus", "id", "isLoading", "labelOn", "labelOff", "size", "state", "value"]);

    var _b = this.state,
        checked = _b.checked,
        isActive = _b.isActive,
        isFocused = _b.isFocused;
    var shouldShowChecked = !isLoading && checked;
    var shouldShowActive = !isLoading && isActive;
    var componentClassName = classNames_1.classNames('c-Switch', disabled && 'is-disabled', shouldShowChecked && 'is-checked', isLoading && 'is-loading', size && "is-" + size, state && "is-" + state, className);
    var backdropClassName = classNames_1.classNames('c-Switch__backdrop', shouldShowChecked && 'is-checked', disabled && 'is-disabled', isFocused && 'is-focused', size && "is-" + size);
    var toggleClassName = classNames_1.classNames('c-Switch__toggle', shouldShowChecked && 'is-checked', shouldShowActive && 'is-active', isFocused && 'is-focused', isLoading && 'is-loading', size && "is-" + size);
    var stateMarkup = state && React.createElement(Switch_css_js_1.StateUI, {
      className: "c-Switch__state"
    });
    var switchLabel = checked ? labelOn : labelOff;
    return React.createElement(Context_1.default.Consumer, null, function (props) {
      return React.createElement(Switch_css_js_1.WrapperUI, {
        className: "c-SwitchWrapper"
      }, React.createElement(Switch_css_js_1.SwitchUI, __assign({}, getValidProps_1.default(rest), {
        className: componentClassName,
        htmlFor: _this.getIdFromContextProps(props),
        onMouseDown: _this.handleOnMouseDown,
        onMouseUp: _this.handleOnMouseUp
      }), _this.getInputMarkup(props), React.createElement(Switch_css_js_1.BackdropUI, {
        className: backdropClassName
      }, React.createElement(Switch_css_js_1.ToggleUI, {
        className: toggleClassName
      })), stateMarkup, React.createElement(VisuallyHidden_1.default, null, switchLabel)));
    });
  };

  Switch.defaultProps = {
    inputRef: other_1.noop,
    innerRef: other_1.noop,
    isLoading: false,
    labelOn: 'On',
    labelOff: 'Off',
    onBlur: other_1.noop,
    onChange: other_1.noop,
    onClick: other_1.noop,
    onFocus: other_1.noop,
    onMouseDown: other_1.noop,
    onMouseUp: other_1.noop,
    size: 'md',
    value: ''
  };
  return Switch;
}(React.PureComponent);

component_1.namespaceComponent(utils_1.COMPONENT_KEY)(Switch);
exports.default = Switch;